import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { InlineImage } from 'libs/editor/styles';

@observer
class ImageInlineNode extends React.Component {
  render() {
    const { node, isSelected, attributes } = this.props;
    const src = node.data.get('src');
    return (
      <InlineImage selected={isSelected} {...attributes}>
        <img src={src} />
      </InlineImage>
    );
  }
}

ImageInlineNode.propTypes = {
  node: PropTypes.object,
  isSelected: PropTypes.bool,
  attributes: PropTypes.object,
};

export function Image() {
  return {
    plugins: [RenderNode('image', props => <ImageInlineNode {...props} />)],
  };
}
